import React from 'react'
import { Field, makeStyles, ProgressBar } from '@fluentui/react-components'
import { t } from '../../i18n/i18n'
import QRCode from 'react-qr-code'
import { Text } from '../common/text/Text'
import { CollectAndAuthResponse } from '../../api/schemas/schema'

const useStyles = makeStyles({
   resetBtnValues: {
      border: 'none',
      background: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'block',
   },
})
type QRCodeDisplayProps = {
   qrCodeValue: CollectAndAuthResponse
   enterFullscreen: () => void
   exitFullscreen: () => void
   isFullscreen: boolean
}
export const QRCodeDisplay = ({ qrCodeValue, enterFullscreen, exitFullscreen, isFullscreen }: QRCodeDisplayProps) => {
   const qrCodeAltText = t('QRCodeAltText')
   const classes = useStyles()
   return (
      <>
         <Text align="center">{t('BankIdInstructions')}</Text>
         <figure aria-label={t('QRCodeAltText')}>
            <button type="button" onClick={isFullscreen ? exitFullscreen : enterFullscreen} aria-label={qrCodeAltText} className={classes.resetBtnValues}>
               <QRCode value={qrCodeValue.qrString} />
               <Field aria-hidden="true" validationMessage={`${qrCodeValue.totalTime - qrCodeValue.currentTime} ${t('SecondsLeft')}`} validationState="none">
                  <ProgressBar thickness="large" max={qrCodeValue.totalTime} value={qrCodeValue.currentTime} />
               </Field>

               <figcaption style={{ display: 'none' }}>{qrCodeAltText}</figcaption>
            </button>
         </figure>
      </>
   )
}
